import React from 'react'
import moment from 'moment'
import { getInLocal, getValidCoupon } from '../../utils/app-helpers'
import GatsbyConfig from '../../../gatsby-config'

const { siteMetadata: config } = GatsbyConfig

export default ({ trip }) => {
  const tripData = config.trips[trip]
  const cachedCoupon = getInLocal(`lsg.coupon.${trip}`, true)

  if (!cachedCoupon) return null

  const coupon = getValidCoupon(cachedCoupon.code, tripData.coupons)

  if (!coupon) return null

  const expiration = moment(coupon.expiration).format('M/D/YY')
  const labelLine1 = coupon.labelLine1 || `Save ${coupon.value} with promo "${coupon.code}".`
  const labelLine2 = coupon.labelLine1 ? coupon.labelLine2 : `Ends: ${expiration}`

  return (
    <div className="coupon-reminder">
      <div className="wrap">
        <p>
          {labelLine1}
          {labelLine2 && <br />}
          {` ${labelLine2}`}
        </p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/partials/coupon-reminder.js